import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { FeaturedProjects } from '../components/home/FeaturedProjects';
import { LatestBids } from '../components/home/LatestBids';
import { ProcurementQuickLinks } from '../components/home/ProcurementQuickLinks';
import { NewsSection } from '../components/home/NewsSection';
import { CTASection } from '../components/home/CTASection';
export function Home() {
  return <div data-id="element-781">
      <HeroSection data-id="element-782" />
      <StatsSection data-id="element-783" />
      <FeaturedProjects data-id="element-784" />
      <LatestBids data-id="element-785" />
      <ProcurementQuickLinks data-id="element-786" />
      <NewsSection data-id="element-787" />
      <CTASection data-id="element-788" />
    </div>;
}